import { useEffect } from 'react';
import Lenis from 'lenis';

export const scrollToSection = (id, focusForm = false) => {
  const target = document.getElementById(id.replace(/^#/, ''));
  if (!target) return;
  const header = document.querySelector('.site-header');
  const headerHeight = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position) ? header.getBoundingClientRect().height : 0;
  const destination = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 16);
  if (window.sabeScroll) {
    window.sabeScroll.resize();
    window.sabeScroll.scrollTo(destination, { duration: 0.85, force: true });
  } else window.scrollTo({ top: destination, behavior: 'instant' });
  if (focusForm) document.getElementById('lead-name')?.focus({ preventScroll: true });
  if (id === '#main-content') {
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }
};

export const useSmoothNavigation = (modalOpen) => {
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const lenis = reduced ? null : new Lenis({ autoRaf: true, duration: 1.05, anchors: false, stopInertiaOnNavigate: false, prevent: node => !!node.closest('[data-lenis-prevent]') });
    if (lenis) window.sabeScroll = lenis;
    const handleAnchor = event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href^="#"]');
      const hash = link?.getAttribute('href');
      if (!hash || hash === '#' || !document.getElementById(hash.slice(1))) return;
      event.preventDefault();
      window.history.replaceState(null, '', hash);
      requestAnimationFrame(() => scrollToSection(hash));
    };
    document.addEventListener('click', handleAnchor, true);
    return () => { document.removeEventListener('click', handleAnchor, true); lenis?.destroy(); delete window.sabeScroll; };
  }, []);
  useEffect(() => {
    if (modalOpen) window.sabeScroll?.stop();
    else window.sabeScroll?.start();
  }, [modalOpen]);
};